import React, { useState, useEffect, useRef } from 'react';
import { useChartLogic, ChartCore, ChartAnnotations, ChartOverlay } from './chart/index';
// import ChartInfoBar from './chart/ChartInfoBar';
// import ChartMainArea from './chart/ChartMainArea';
import BettingOverlay from './betting/BettingOverlay';
import ChartVolumeBar from './chart/ChartVolumeBar';
import ChartInfoBar from './chart/ChartInfoBar';

export default function Chart({ 
  chartData: initialChartData, 
  priceChange, 
  symbol, 
  onAreaClick,
  showBettingOverlay,
  bettingData,
  onCloseBettingOverlay,
  onPriceUpdate
}) {
  const [isChartHovered, setIsChartHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const hoverTimeoutRef = useRef(null);

  // 处理悬停状态变化
  useEffect(() => {
    if (isChartHovered) {
      // 开始悬停，2秒后显示提示
      hoverTimeoutRef.current = setTimeout(() => {
        setShowTooltip(true);
      }, 1000);
    } else {
      // 停止悬停，清除定时器和提示
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = null;
      }
      setShowTooltip(false);
    }

    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, [isChartHovered]);
  const {
    data,
    chartRef,
    lastPrice,
    prices,
    minY,
    maxY,
    hoverY,
    chartWidth,
    handleMouseMove,
    handleMouseLeave,
    handleAreaClick
  } = useChartLogic(initialChartData);

 

  // 新增：每次data变化时，把最新价通知父组件
  useEffect(() => {
    if (onPriceUpdate && data.length) {
      onPriceUpdate(data[data.length - 1].price);
    }
  }, [data, onPriceUpdate]);

  // 处理点击事件
  const handleClick = (area) => {
    if (onAreaClick) {
      onAreaClick(symbol, area);
    }
  };

  return (
    <div className="relative w-full h-full flex flex-col" style={{height: '100%'}}>
      {/* 渐显动画样式 */}
      <style>{`
        .animate-fade-in {
          animation: fadeIn 0.3s ease-in-out;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-4px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      {/* ChartOverlay（下注蒙版等） */}

      {/* 顶部信息区 1/5 留白 */}
      <div className="flex-none" style={{flex: 2}}>
        <ChartInfoBar
          dataChart={data}
        />
      </div>
      {/* 中部主图区 3/5 恢复ChartCore及相关内容 */}
      <div className="flex-1 relative" style={{flex: 6, minHeight:0}}>
        {/* 悬停提示层 - 位于图表主区域 */}
        {!showBettingOverlay && showTooltip && (
          <div className="absolute top-2 right-6 z-10 pointer-events-none animate-fade-in">
            <div className="bg-orange-500/30 text-white px-2 py-1 rounded text-xs font-medium backdrop-blur-sm">
              Click to Pred
            </div>
          </div>
        )}
        <ChartCore
          data={data}
          chartRef={chartRef}
          priceChange={priceChange}
          handleMouseMove={handleMouseMove}
          handleMouseLeave={handleMouseLeave}
          onChartHover={setIsChartHovered}
          minY={minY}
          maxY={maxY}
        >
          <ChartAnnotations 
            data={data}
            prices={prices}
            lastPrice={lastPrice}
            minY={minY}
            maxY={maxY}
            hoverY={hoverY}
            onAreaClick={handleClick}
          />
        </ChartCore>
        <ChartOverlay chartWidth={chartWidth} />
      </div>
      {/* 底部bar区 1/5 */}
      <div className="flex-none" style={{flex: 1, minHeight:0}}>
        <ChartVolumeBar data={data} />
      </div>

      
      {/* 蒙版组件 */}
      <BettingOverlay
        show={showBettingOverlay}
        onClose={onCloseBettingOverlay}
        symbol={bettingData.symbol}
        area={bettingData.area}
        lastPrice={lastPrice}
      />
    </div>
  );
}
